/**
 * Tara Consultation - Results Data Bridge
 * Bootstraps the results state from Liquid JSON and stored consultation data.
 */

(function () {
  'use strict';

  const DEFAULT_CONSULTATION_PATH = '/pages/consultation';

  function getResultsStateApi() {
    return window.TaraConsultationResultsState || null;
  }

  function captureMonitoringException(error, meta) {
    const api = getResultsStateApi();
    if (api && typeof api.captureMonitoringException === 'function') {
      api.captureMonitoringException(error, meta || {});
    }
  }

  function captureMonitoringMessage(message, meta) {
    const api = getResultsStateApi();
    if (api && typeof api.captureMonitoringMessage === 'function') {
      api.captureMonitoringMessage(message, meta || {});
    }
  }

  function parseJSON(id) {
    try {
      const el = document.getElementById(id);
      return el ? JSON.parse(el.textContent) : null;
    } catch (error) {
      console.warn('[Tara Consultation] Could not parse', id, error);
      captureMonitoringException(error, {
        error_code: 'results_bridge_json_parse_failed',
        level: 'error',
        fingerprint: ['tara-consultation', 'results-bridge-json-parse', id],
        extra: { script_id: id },
      });
      return null;
    }
  }

  function trackResultsViewed(assessment, isDesignMode) {
    if (isDesignMode) return;

    window.TaraMetaSignals?.emit('ConsultationResultsViewed', assessment.assessment_id);
    if (typeof gtag === 'function') {
      gtag('event', 'consultation_results_viewed', { concern_level: assessment.concern_level || null });
    }
  }

  function init(sectionId) {
    const api = getResultsStateApi();
    if (!api || typeof api.getOrCreateStore !== 'function' || typeof api.buildResultsState !== 'function') {
      throw new Error('Results state helpers are unavailable');
    }

    try {
      const catalogArr = parseJSON(`TaraConsultationProductCatalog-${sectionId}`) || [];
      const bundleFamilies = parseJSON(`TaraConsultationBundleFamilies-${sectionId}`) || {};
      const parsedConfig = parseJSON(`TaraConsultationDataBridgeConfig-${sectionId}`) || {};
      const config = {
        consultationPageUrl: parsedConfig.consultationPageUrl || DEFAULT_CONSULTATION_PATH,
        ...parsedConfig,
      };
      const store = api.getOrCreateStore();
      const helpers = store.getHelpers();
      const isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;

      const state = api.buildResultsState({
        sectionId,
        catalogArr,
        bundleFamilies,
        parsedConfig: config,
        isDesignMode,
        helpers,
      });

      api.publishState(sectionId, state);
      if (!state.empty && state.assessment) {
        trackResultsViewed(state.assessment, isDesignMode);
      }
    } catch (error) {
      error.__taraMonitoringCaptured = true;
      captureMonitoringException(error, {
        error_code: 'results_bridge_init_failed',
        level: 'error',
        sectionId,
        fingerprint: ['tara-consultation', 'results-bridge-init-failed', String(sectionId || '')],
      });
      throw error;
    }
  }

  if (
    new URLSearchParams(window.location.search).get('seed') === '1'
    && typeof Shopify !== 'undefined'
    && Shopify.designMode
  ) {
    const api = getResultsStateApi();
    if (api && typeof api.getDesignModeSampleResult === 'function') {
      sessionStorage.setItem('taraConsultationAssessment', JSON.stringify({
        assessment: api.getDesignModeSampleResult(),
      }));
    }
    const url = new URL(window.location.href);
    url.searchParams.delete('seed');
    window.location.replace(url.toString());
    return;
  }

  try {
    const api = getResultsStateApi();
    if (api && typeof api.getOrCreateStore === 'function') {
      api.getOrCreateStore();
    }

    const bridges = document.querySelectorAll('[data-tara-consultation-bridge]');
    if (!bridges.length) {
      console.error('[Tara Consultation] Bridge element not found');
      captureMonitoringMessage('Consultation results bridge element was not found', {
        error_code: 'results_bridge_missing',
        level: 'error',
        fingerprint: ['tara-consultation', 'results-bridge-missing'],
      });
      return;
    }

    bridges.forEach(function bootBridge(bridge) {
      init(bridge.dataset.sectionId);
    });
  } catch (error) {
    console.error('[Tara Consultation] Data bridge init failed:', error);
    if (!error || !error.__taraMonitoringCaptured) {
      captureMonitoringException(error, {
        error_code: 'results_bridge_init_failed',
        level: 'error',
        fingerprint: ['tara-consultation', 'results-bridge-init-failed'],
      });
    }
  }
})();
